import { render } from "./PVDataTableZASumme.vue?vue&type=template&id=edacd81c"
import script from "./PVDataTableZASumme.vue?vue&type=script&lang=js"
export * from "./PVDataTableZASumme.vue?vue&type=script&lang=js"

import "./PVDataTableZASumme.vue?vue&type=style&index=0&id=edacd81c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__